import {handleActions} from 'redux-actions';

import {CONTENT_PARTNERS_SET} from './ContentPartnersActions';

export const ascendingSort = (a: any, b: any) => {
    const aUpper = a.label.toUpperCase();
    const bUpper = b.label.toUpperCase();
    
    if (aUpper < bUpper)
        return -1;
    
    if (aUpper > bUpper)
        return 1;
    
    return 0;
};

export const mapPartnerToOption = ({id, partnerName}:any) => ({
    value: id.toString(),
    label: partnerName,
});

export const setContentPartners = (state: any, {payload}:any) => {
    if (!payload)
        return {
            ...state,
            isLoading: false,
        };
    
    if (payload.total) {
        const rows = payload.rows
            .map(mapPartnerToOption)
            .sort(ascendingSort);
        
        return {
            isLoading: false,
            data: {
                total: payload.total,
                rows,
            },
        };
    }
    
    return {
        ...state,
        isLoading: false,
    };
};

export const initialState = {
    data: {},
    isLoading: true,
};

const handlers = {
    [CONTENT_PARTNERS_SET]: setContentPartners,
};

export default handleActions(handlers, initialState);
